import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createRuleSet = api(async function createRuleSet({ name, description, defaultAction }) {
    return mutate(
        gql`
            mutation CreateRuleSet($name: String!, $description: String, $defaultAction: String) {
                createRuleSet(name: $name, description: $description, defaultAction: $defaultAction) {
                    id
                    name
                    type
                    defaultAction
                }
            }
        `,
        { name, description, defaultAction },
        { returns: "createRuleSet" }
    )
})
